import React, { useContext } from 'react';
import loginImage from '../../images/loginImage.png';
import { useForm } from "react-hook-form";
import firebase from "firebase/app";
import "firebase/auth";
import { firebaseConfig } from './firebase.config';
import { UserContext } from '../../App';

const Login = () => {
    const [loggedInUser, setLoggedInUser] = useContext(UserContext);
    if (firebase.apps.length === 0) {
        firebase.initializeApp(firebaseConfig);
      }
    
    const handleGoogleSign = () => {
        const provider = new firebase.auth.GoogleAuthProvider();
        firebase.auth().signInWithPopup(provider)
        .then((result) => {
            var {displayName,email} = result.user;
            const signInUser = {
                name: displayName,
                email
            }
            setLoggedInUser(signInUser);
        }).catch((error) => {
            var errorMessage = error.message;
            console.log(errorMessage);
        });

    }

    const { register, handleSubmit, formState: { errors } } = useForm();
    const onSubmit = data => {
        console.log(data);
    };
    return (
        <div className='container'>
            <div className="row">
                <div className="col-md-5 my-auto">
                    <div className='shadow p-5'>
                        <h5 className='text-center mb-5'>Login</h5>
                        <form onSubmit={handleSubmit(onSubmit)}>

                            <div class="form-floating mb-3">
                                <input id="floatingInput" placeholder='Email Address' type="email" name='Email' class="form-control border-0 border-bottom border-dark rounded-0 p-0" style={{boxShadow:'none'}}  {...register("email", { required: true })}/>
                                <label className='ps-0' for="floatingInput">Email address</label>
                                {errors.email && <span class="text-danger">This field is required</span>}
                            </div>

                            <div class="form-floating mb-3">
                                <input id='floatingPassword' placeholder="Password" type="password" name='password' class="form-control border-0 border-bottom border-dark rounded-0 p-0" style={{boxShadow:'none'}} {...register("password", { required: true })}/>
                                <label className='ps-0' for="floatingPassword">Password</label>
                                {errors.password && <span class="text-danger">This field is required</span>}
                            </div>

                            <div className='d-grid'>
                                <button className='btn-similar' type='submit'>Sign Up</button>
                            </div>
                        </form>
                        <h6 style={{cursor:'pointer'}} className='mt-1' onClick={handleGoogleSign}>Sign With Google</h6>
                    </div>
                </div>
                <div className="col-md-7">
                    <img className='img-fluid ms-5' src={loginImage} style={{height:'100vh'}} alt="" />
                </div>
            </div>
        </div>
    );
};

export default Login;